import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiDropdownModule } from "@webapp/ui/dropdown/dropdown.module";
import { UiThemeType } from "@webapp/ui/icon/icon.models";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiMenuModule } from "@webapp/ui/menu/menu.module";

@Component({
  selector: "button-split",
  templateUrl: "./button-split.component.html",
  styleUrls: ["./button-split.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UiIconModule, UiButtonModule, UiDropdownModule, UiMenuModule],
})
export class ButtonSplitComponent {
  @Input() public buttonText: string;
  @Output() public readonly buttonClick = new EventEmitter<void>();

  @Input() public uiType = "chevron-down-small";
  @Input() public uiTheme: UiThemeType = "outline";

  public onClick(): void {
    this.buttonClick.next();
  }
}
